// Modo "Videos cortos" (ADR-2026-10-22-videos-masivos-diseno-de-produccion,
// ADR-2026-10-30-videos-cortos-con-el-agente): elegís productos de tu catálogo (hasta 50), el
// agente planea un video vertical de ~15 s de cada uno (guion del director de Atlas y voz en off
// elegida por producto), revisás las tarjetas y creás. 12 créditos por video, de Pro para arriba
// (ADR-2026-10-31-videos-cortos-es-de-pro-y-ultra: las listas le ponen candado y acá se vuelve a
// mirar, porque la URL se puede escribir a mano). Sin `:sesionId` es la portada; con él, la
// sesión (un chat de tipo `videos-cortos`).
// Provee los productos de la marca activa (`ProductsContext`, que `PickProductPanel` lee), como
// el Catálogo. Espera a que el rubro resuelva: con `brandId` en null, `fetchUserProducts` traería
// el catálogo de TODA la empresa.
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { PantallaDePisoDePlan, usePisoDePlan } from '../../../components/PisoDePlan';
import { useRubroMarcaActiva } from '../../../hooks/useRubroMarca';
import { useAgentEnv } from '../agentEnvContext';
import type { MockProductV2 } from '../mockData';
import { fetchUserProducts } from '../productsApi';
import { ProductsContext, ProductsLoadedContext } from '../productsContext';
import { PortadaDeVideosCortos } from './videosCortos/PortadaDeVideosCortos';
import { SesionDeVideosCortos } from './videosCortos/SesionDeVideosCortos';

export default function VideosCortosMode() {
  const { sesionId } = useParams<{ sesionId?: string }>();
  const { companyId, brandId } = useAgentEnv();
  const { rubro, loaded: rubroCargado } = useRubroMarcaActiva();
  const [productos, setProductos] = useState<MockProductV2[]>([]);
  const [cargados, setCargados] = useState(false);
  const [version, setVersion] = useState(0);
  const lock = usePisoDePlan('videos-cortos');

  useEffect(() => {
    if (!companyId || !rubroCargado) return;
    let cancelado = false;
    (async () => {
      try {
        const lista = await fetchUserProducts(companyId, brandId ?? null);
        if (!cancelado) setProductos(lista);
      } catch (e) {
        console.error('[VideosCortosMode] productos', e);
      } finally {
        if (!cancelado) setCargados(true);
      }
    })();
    return () => {
      cancelado = true;
    };
  }, [companyId, brandId, rubroCargado, version]);

  if (lock) return <PantallaDePisoDePlan lock={lock} />;
  return (
    <ProductsContext.Provider value={productos}>
      <ProductsLoadedContext.Provider value={cargados}>
        {sesionId ? <SesionDeVideosCortos key={sesionId} sesionId={sesionId} /> : <PortadaDeVideosCortos rubro={rubro} onProductosNuevos={() => setVersion((v) => v + 1)} />}
      </ProductsLoadedContext.Provider>
    </ProductsContext.Provider>
  );
}
